import { Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IAgsExport } from 'Data/ViewModels/Ags';
import { FormatTypes } from 'Lib/Format';
import React from 'react';
import { useSelector } from 'react-redux';
import './AgsExportHeader.scss';

const ProjectAgsExportHeaderFields: React.FC<IAgsExport> = (agsExport: IAgsExport) => (
  <ListFieldSection>
    <Field input={<TextOutput />} label="Project" value={agsExport.Project.Name} />
    <Field input={<TextOutput />} label="Client" value={agsExport.Project.ClientName} />
    <Field input={<TextOutput />} label="Start Date" format={{ type: FormatTypes.Date }} value={agsExport.StartDate} />
    <Field input={<TextOutput />} label="End Date" format={{ type: FormatTypes.Date }} value={agsExport.EndDate} />
  </ListFieldSection>
);

const WorkOrderAgsExportHeaderFields: React.FC<IAgsExport> = (agsExport: IAgsExport) => (
  <ListFieldSection>
    <Field input={<TextOutput />} label="Project" value={agsExport.WorkOrder?.ProjectName} />
    <Field input={<TextOutput />} label="Client" value={agsExport.WorkOrder?.ClientName} />
    <Field input={<TextOutput />} label="Work Order" value={agsExport.WorkOrder?.WorkOrderId} />
    <Field
      input={<TextOutput />}
      label="Work Date"
      format={{ type: FormatTypes.Date }}
      value={agsExport.WorkOrder?.WorkDate}
    />
  </ListFieldSection>
);

const isProjectExport = (agsExport: IAgsExport) =>
  !!(!agsExport.WorkOrder && agsExport.Project && agsExport.StartDate && agsExport.EndDate);
const isWorkOrderExport = (agsExport: IAgsExport) => !!agsExport.WorkOrder;

const AgsExportHeaderBase: React.FC = () => {
  const agsExport = useSelector((s) => s.agsExport.agsExport);
  const header = useSelector((s) => s.agsExport.pageHeader);
  if (window.qest.isFrame) {
    return null;
  }
  return (
    <header className="AgsExportHeader">
      <section className="AgsExportHeader-Headings">
        <span className="AgsExportHeader-Heading AgsExportHeader-Heading-smallHide">{header.description}</span>
        <span className="AgsExportHeader-Heading AgsExportHeader-Heading-largeHide">{header.shortName}</span>
      </section>
      <div className="AgsExportHeader-Fields">
        {agsExport && isWorkOrderExport(agsExport) && <WorkOrderAgsExportHeaderFields {...agsExport} />}
        {agsExport && isProjectExport(agsExport) && <ProjectAgsExportHeaderFields {...agsExport} />}
      </div>
    </header>
  );
};
const AgsExportHeader = withInjectedProps(AgsExportHeaderBase);

export { AgsExportHeader };
export default AgsExportHeader;
